import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const ticketStatusUpdate = createAsyncThunk("ticketStatusUpdate", async ({ id, data }, { rejectWithValue }) => {
	try {
		const response = await axiosHttp.patch(`desk/updatestatus?id=${id}`, data);
		return response.data;
	} catch (err) {
		if (!err.response) {
			throw err;
		}
		return rejectWithValue(err.response.data);
	}
});

const TicketStatusUpdate = createSlice({
	name: "TicketStatusUpdate",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(ticketStatusUpdate.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(ticketStatusUpdate.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(ticketStatusUpdate.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default TicketStatusUpdate.reducer;
